const API_RESPONSE = "API_RESPONSE";
const PAGE_LOADING = "PAGE_LOADING";
const CONTENT_LOADING = "CONTENT_LOADING";
const SNACKBAR = "SNACKBAR";
const SEARCH_RESULTS = "SEARCH_RESULTS";
const TOGGLE_CONFIRM = "TOGGLE_CONFIRM";
const IS_SAVING = "IS_SAVING";
const ADD_ERROR = "ADD_ERROR";
const CLEAR_ERROR_BY_FIELD = "CLEAR_ERROR_BY_FIELD";
const CLEAR_ERRORS = "CLEAR_ERRORS";
const LOADING = "LOADING";
const RESET_CONFIRM = "RESET_CONFIRM";
const SOMETHING_SAVING = "SOMETHING_SAVING";
const SET_ERROR_PANELS_EXPANDED = "SET_ERROR_PANELS_EXPANDED";
const TOGGLE_CHECK_ERROR_PANELS = "TOGGLE_CHECK_ERROR_PANELS";
const NOTIFICATION = "NOTIFICATION";
const SET_STATUS_TRACKER_ACTIVE = "SET_STATUS_TRACKER_ACTIVE";
const SET_STATUS_TRACKER_CONFIG = "SET_STATUS_TRACKER_CONFIG";
const CLEAR_STATUS_TRACKER = "CLEAR_STATUS_TRACKER";
const CLEAR_ERROR_BY_NESTED_FIELD = "CLEAR_ERROR_BY_NESTED_FIELD";
const SET_SUBMIT_CLICKED = "SET_SUBMIT_CLICKED";

export default {
    API_RESPONSE,
    PAGE_LOADING,
    CONTENT_LOADING,
    SNACKBAR,
    SEARCH_RESULTS,
    TOGGLE_CONFIRM,
    IS_SAVING,
    ADD_ERROR,
    CLEAR_ERROR_BY_FIELD,
    CLEAR_ERRORS,
    LOADING,
    RESET_CONFIRM,
    SOMETHING_SAVING,
    SET_ERROR_PANELS_EXPANDED,
    TOGGLE_CHECK_ERROR_PANELS,
    NOTIFICATION,
    SET_STATUS_TRACKER_ACTIVE,
    SET_STATUS_TRACKER_CONFIG,
    CLEAR_STATUS_TRACKER,
    CLEAR_ERROR_BY_NESTED_FIELD,
    SET_SUBMIT_CLICKED,
};
